import styled from 'styled-components';
import { isMobile } from 'utils/is-mobile';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: var(--v3-black-0);
  ${isMobile()
    ? `
      margin-top: 4px;
    `
    : `
     border-radius: 6px;
     overflow: auto;
     margin-bottom: 4px;
    `}
`;

export const New = styled.span`
  height: 12px;
  font-size: 7px;
  background-color: #ff6262;
  color: #fff;
  padding: 1px 6px;
  border-radius: 4px;
  letter-spacing: 0.1px;
  line-height: 10px;
  margin-left: 4px;
  margin-top: -6px;
`;

export const Menu = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-y: hidden;
  padding-left: 6px;
`;

export const FavoritesCount = styled.span`
  font-size: 14px;
  font-weight: 600;
  margin-left: 6px;
  line-height: 0.85;
`;
